module.exports = __webpack_public_path__ + "img/spartan-sheetrock-framing-texture-03-xxlarge.3808df69.jpg";